<template>
<div>
    <div id="envelope" class="wrapper">
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 外皮 -->
        <app-error-list/>
        <app-section v-if="bsc_type == 1 || bsc_type == 2">
            <h3 slot="h3">
                <parts-arrow category="外皮">1</parts-arrow>
                <span>外皮性能の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="外皮性能の評価方法" 
                class="flex_column"
                @click="guideTransition"
                name="ip_houhou"
            >
                <app-radio
                    v-for="(name, value) in master.ip_houhou"
                    v-model="ip_houhou"
                    :value="value"
                    unit=""
                    :key="'ip_houhou' + value"
                    :disabled="value >= 2 && tatekataChecker"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>

        <!-- 外皮性能の評価方法＝1の時（当該住戸の外皮面積を用いて外皮性能を評価する） -->
        <app-section v-if="ip_houhou == 1 && (bsc_type == 1 || bsc_type == 2)">
            <h3 slot="h3">
                <parts-arrow category="外皮">2</parts-arrow>
                <span>
                    <parts-arrow class="line">1</parts-arrow>で「当該住戸の外皮面積を用いて外皮性能を評価する」を選択した場合、外皮の仕様を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="外皮面積の合計" 
                class="flex_column"
                @click="guideTransition"
                name="bsc_sougaihi_menseki"
            >
                <app-text
                    label=""
                    unit="m2"
                    v-model="bsc_sougaihi_menseki"
                    min="1.00"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="外皮平均熱貫流率（U<sub>A</sub>）" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_value"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_value"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="冷房期平均日射熱取得率（η<sub>AC</sub>）" 
                class="flex_column"
                @click="guideTransition"
                name="ss_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="ss_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
            <app-box
                v-if="!isOndanchi"
                :available="true"
                label="暖房期平均日射熱取得率（η<sub>AH</sub>）" 
                class="flex_column"
                @click="guideTransition"
                name="sw_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="sw_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
        </app-section>

        <!-- 外皮性能の評価方法＝2の時（当該住戸の外皮面積を用いず外皮性能を評価する（別途計算）） -->
        <app-section v-if="ip_houhou == 2 && (bsc_type == 1 || bsc_type == 2)">
            <h3 slot="h3">
                <parts-arrow category="外皮">2</parts-arrow>
                <span>
                    <parts-arrow class="line">1</parts-arrow>で「当該住戸の外皮面積を用いず外皮性能を評価する（別途計算）」を選択した場合、外皮の仕様を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="住戸の種類" 
                class="flex_row"
                @click="guideTransition"
                name="ip_yuka_dannetsu"
            >
                <app-radio
                    v-for="(name, value) in master.ip_yuka_dannetsu"
                    v-model="ip_yuka_dannetsu"
                    :value="value"
                    unit=""
                    :key="'ip_yuka_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                v-if="ip_yuka_dannetsu == 2"
                :available="true"
                label="浴室の断熱構造" 
                class="flex_column"
                @click="guideTransition"
                name="ip_bath_dannetsu"
            >
                <app-radio
                    v-for="(name, value) in master.ip_bath_dannetsu"
                    v-model="ip_bath_dannetsu"
                    :value="value"
                    unit=""
                    :key="'ip_bath_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="外皮平均熱貫流率（U<sub>A</sub>）" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_value"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_value"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="冷房期平均日射熱取得率（η<sub>AC</sub>）" 
                class="flex_column"
                @click="guideTransition"
                name="ss_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="ss_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
            <app-box
                v-if="!isOndanchi"
                :available="true"
                label="暖房期平均日射熱取得率（η<sub>AH</sub>）" 
                class="flex_column"
                @click="guideTransition"
                name="sw_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="sw_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
        </app-section>

        <!-- 外皮性能の評価方法＝3の時（当該住戸の外皮面積を用いず外皮性能を評価する（ここで計算）） -->
        <app-section v-if="ip_houhou == 3 && (bsc_type == 1 || bsc_type == 2)">
            <h3 slot="h3">
                <parts-arrow category="外皮">2</parts-arrow>
                <span>
                    <parts-arrow class="line">1</parts-arrow>で「当該住戸の外皮面積を用いず外皮性能を評価する（ここで計算）」を選択した場合、外皮の仕様を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="構造の種別" 
                class="flex_column"
                @click="guideTransition"
                name="ip_structure"
            >
                <app-radio
                    v-for="(name, value) in master.ip_structure"
                    v-model="ip_structure"
                    :value="value"
                    unit=""
                    :key="'ip_structure' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="住戸の種類" 
                class="flex_column"
                @click="guideTransition"
                name="ip_house_dannetsu"
            >
                <app-radio
                    v-for="(name, value) in master.ip_house_dannetsu"
                    v-model="ip_house_dannetsu"
                    :value="value"
                    unit=""
                    :key="'ip_house_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                v-if="ip_house_dannetsu == 1 || ip_house_dannetsu == 3"
                :available="true"
                label="浴室の断熱構造" 
                class="flex_column"
                @click="guideTransition"
                name="ip_bath_dannetsu"
            >
                <app-radio
                    v-for="(name, value) in master.ip_bath_dannetsu"
                    v-model="ip_bath_dannetsu"
                    :value="value"
                    unit=""
                    :key="'ip_bath_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                :available="true"
                label="屋根又は天井の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_roof"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_roof"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="壁の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_wall"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_wall"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="ドアの熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_door"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_door"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                :available="true"
                label="窓の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_window"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_window"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                v-if="isBathYukaDannetsu"
                :available="true"
                label="浴室の床の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_floor_bath"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_floor_bath"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isBathYukaDannetsu"
                />
            </app-box>
            <app-box
                v-if="isYukaDannetsu"
                :available="true"
                label="その他の床の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_floor_other"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_floor_other"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isYukaDannetsu"
                />
            </app-box>
            <app-box
                :available="true"
                label="玄関等の基礎の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_base_etrc"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_base_etrc"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                v-if="ip_bath_dannetsu == 2 && ip_house_dannetsu != 2"
                :available="true"
                label="浴室の基礎の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_base_bath"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_base_bath"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="ip_bath_dannetsu != 2 || ip_house_dannetsu == 2"
                />
            </app-box>
            <app-box
                v-if="isDomayuka"
                :available="true"
                label="その他の基礎の熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_base_other"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_base_other"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isDomayuka"
                />
            </app-box>
            <app-box
                :available="true"
                label="玄関等の土間床等の外周部の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_prm_etrc"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_prm_etrc"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                v-if="isBathDomayuka"
                :available="true"
                label="浴室の土間床等の外周部の線熱貫流率" 
                @click="guideTransition"
                name="ip_psi_prm_bath"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_prm_bath"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isBathDomayuka"
                />
            </app-box>
            <app-box
                v-if="isDomayuka"
                :available="true"
                label="その他の土間床等の外周部の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_prm_other"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_prm_other"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="!isDomayuka"
                />
            </app-box>
            <app-box
                v-if="!isMokuzou"
                :available="true"
                label="屋根または天井の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_roof"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_roof"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                v-if="!isMokuzou"
                :available="true"
                label="壁の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_wall"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_wall"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                v-if="!isMokuzou"
                :available="true"
                label="床の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_floor"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_floor"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                v-if="!isMokuzou"
                :available="true"
                label="屋根または天井と壁の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_roof_wall"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_roof_wall"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                v-if="!isMokuzou"
                :available="true"
                label="壁と壁の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_wall_wall"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_wall_wall"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                v-if="!isMokuzou"
                :available="true"
                label="壁と床の熱橋の線熱貫流率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_psi_heatbridge_wall_floor"
            >
                <app-text
                    label=""
                    unit="W/mK"
                    v-model="ip_psi_heatbridge_wall_floor"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                    :disabled="isMokuzou"
                />
            </app-box>
            <app-box
                :available="true"
                label="冷房期の窓の垂直面日射熱取得率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_ss_eta_d_window"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="ip_ss_eta_d_window"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
            <app-box
                v-if="!isOndanchi"
                :available="true"
                label="暖房期の窓の垂直面日射熱取得率" 
                class="flex_column"
                @click="guideTransition"
                name="ip_sw_eta_d_window"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="ip_sw_eta_d_window"
                    :step="0.001"
                    class="number"
                    subscript="(小数点以下3桁)"
                />
            </app-box>
        </app-section>

        <!-- 特定事業主の場合 -->
        <app-section v-if="bsc_type == 3">
            <h3 slot="h3">
                <parts-arrow category="外皮">1</parts-arrow>
                <span>
                    外皮平均熱貫流率を入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="外皮平均熱貫流率(U<sub>A</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="ip_u_value"
            >
                <app-text
                    label=""
                    unit="W/m2K"
                    v-model="ip_u_value"
                    :step="0.01"
                    class="number"
                    subscript="(小数点以下2桁)"
                />
            </app-box>
        </app-section>
        <app-section v-if="bsc_type == 3">
            <h3 slot="h3">
                <parts-arrow category="外皮">2</parts-arrow>
                <span>
                    日射熱取得率について入力して下さい。
                </span>
            </h3>
            <app-box
                :available="true"
                label="冷房期平均日射熱取得率(η<sub>AC</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="ss_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="ss_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
            <app-box
                v-if="!isOndanchi"
                :available="true"
                label="暖房期平均日射熱取得率(η<sub>AH</sub>)" 
                class="flex_column"
                @click="guideTransition"
                name="sw_eta_value"
            >
                <app-text
                    label=""
                    unit=""
                    v-model="sw_eta_value"
                    :step="0.1"
                    class="number"
                    subscript="(小数点以下1桁)"
                />
            </app-box>
        </app-section>
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="外皮">3</parts-arrow>
                <span>通風の利用の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="通風の利用" 
                class="flex_column"
                url="https://house.lowenergy.jp/program#calcsheet_envelope"
                link-to="tool"
            >
                <app-grid-in-box>
                    <span>
                        主たる居室
                        <help-button
                            name="nw_ldk_houhou"
                            @click="guideTransition"
                        />
                    </span>
                    <div class="in_flex_column">
                        <app-radio
                            v-for="(name, value) in master.nw_ldk_houhou"
                            v-model="nw_ldk_houhou"
                            :value="value"
                            unit=""
                            :key="'nw_ldk_houhou' + value"
                        >
                            {{name}}
                        </app-radio>
                    </div>
                </app-grid-in-box>
                <app-grid-in-box
                    v-if="bsc_kyoshitsu_kousei == 1 || bsc_sonotakyoshitsu != 2"
                    class="gridinbox"
                >
                    <span>
                        その他の居室
                        <help-button
                            name="nw_nldk_houhou"
                            @click="guideTransition"
                        />
                    </span>
                    <div class="in_flex_column">
                        <app-radio
                            v-for="(name, value) in master.nw_nldk_houhou"
                            v-model="nw_nldk_houhou"
                            :value="value"
                            unit=""
                            :key="'nw_nldk_houhou' + value"
                        >
                            {{name}}
                        </app-radio>
                    </div>
                </app-grid-in-box>
            </app-box>
        </app-section>

        <app-section>
            <h3 slot="h3">
                <parts-arrow category="外皮">4</parts-arrow>
                <span>蓄熱の利用の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="蓄熱の利用" 
                class="flex_row"
                @click="guideTransition"
                name="sh_nisshanetsuriyo"
            >
                <app-radio
                    v-for="(name, value) in master.sh_nisshanetsuriyo"
                    v-model="sh_nisshanetsuriyo"
                    :value="value"
                    unit=""
                    :key="'sh_nisshanetsuriyo' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>

        <app-section>
            <h3 slot="h3">
                <parts-arrow category="外皮">5</parts-arrow>
                <span>床下空間を経由して外気を導入する換気方式の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="床下空間を経由して外気を導入する換気方式の利用" 
                class="flex_column"
                @click="guideTransition"
                name="ip_ufv"
            >
                <app-radio
                    v-for="(name, value) in master.ip_ufv"
                    v-model="ip_ufv"
                    :value="value"
                    unit=""
                    :key="'ip_ufv' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                label="外気が経由する床下の面積の割合"
                name="ip_ufv_area_rate"
                @click="guideTransition"
                :available="true"
                v-if="ip_ufv == 2"
            >
                <app-text
                    label=""
                    unit="%"
                    v-model="ip_ufv_area_rate"
                    class="number"
                    subscript="(整数)"
                    @click="guideTransition"
                    name="ip_ufv_area_rate"
                />
            </app-box>

            <app-box
                label="床下空間の断熱"
                name="ip_ufv_dannetsu"
                @click="guideTransition"
                :available="true"
                v-if="ip_ufv == 2"
            >
                <app-radio
                    v-for="(name, value) in master.ip_ufv_dannetsu"
                    v-model="ip_ufv_dannetsu"
                    :value="value"
                    unit=""
                    :key="'ip_ufv_dannetsu' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版外皮情報入力画面
 * 
 * [算出プロパティ]
 * isYukaDannetsu ... 床断熱が含まれているか否か
 * isBathYukaDannetsu ... 浴室に床断熱が含まれているか否か
 * isBathDomayuka ... 浴室に基礎断熱が含まれているか否か
 * isDomayuka ... 物件に基礎断熱が含まれているか否か
 * isMokuzou ... 住宅が木造か否か
 * 他は詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageManualBuildingEnvelope",
    computed: {
        ...mapGetters('data', {
            data:'getData',
        }),
        ...mapComputedProperties([
            'ip_houhou',
            'bsc_type',
            'bsc_tatekata',
            'bsc_sougaihi_menseki',
            'bsc_kyoshitsu_kousei',
            'bsc_sonotakyoshitsu',
            'bsc_hikyoshitsu',
            'env_chiki',
            'ip_u_value',
            'ss_eta_value',
            'sw_eta_value',
            'ip_yuka_dannetsu',
            'ip_structure',
            'ip_house_dannetsu',
            'ip_bath_dannetsu',
            'ip_u_roof',
            'ip_u_wall',
            'ip_u_door',
            'ip_u_window',
            'ip_u_floor_bath',
            'ip_u_floor_other',
            'ip_u_base_etrc',
            'ip_u_base_bath',
            'ip_u_base_other',
            'ip_psi_prm_etrc',
            'ip_psi_prm_bath',
            'ip_psi_prm_other',
            'ip_psi_heatbridge_roof',
            'ip_psi_heatbridge_wall',
            'ip_psi_heatbridge_floor',
            'ip_psi_heatbridge_roof_wall',
            'ip_psi_heatbridge_wall_wall',
            'ip_psi_heatbridge_wall_floor',
            'ip_ss_eta_d_window',
            'ip_sw_eta_d_window',
            'ip_window_f_input',
            'ip_window_ss_f',
            'ip_window_sw_f',
            'nw_ldk_houhou',
            'nw_nldk_houhou',
            'sh_nisshanetsuriyo',
            'ip_ufv',
            'ip_ufv_area_rate',
            'ip_ufv_dannetsu'
        ]),
        /**
         * @returns Boolean 物件が共同住宅か否か
         */
        tatekataChecker(){
            return this.bsc_tatekata == '2'
        },
        /**
         * @returns Boolean 床断熱が含まれているか否か
         */
        isYukaDannetsu(){
            return (this.ip_house_dannetsu == 1 || this.ip_house_dannetsu == 3)
        },
        /**
         * @returns Boolean 浴室に床断熱が含まれているか否か
         */
        isBathYukaDannetsu(){
            return (this.ip_house_dannetsu == 1 && this.ip_bath_dannetsu == 1 || this.ip_house_dannetsu == 3 && this.ip_bath_dannetsu == 1)
        },
        /**
         * @returns Boolean 浴室に基礎断熱が含まれているか否か
         */
        isBathDomayuka(){
            return (this.ip_house_dannetsu == 1 && this.ip_bath_dannetsu == 2 || this.ip_house_dannetsu == 3 && this.ip_bath_dannetsu == 2)
        },
        /**
         * @returns Boolean 物件に基礎断熱が含まれているか否か
         */
        isDomayuka(){
            return (this.ip_house_dannetsu == 2 || this.ip_house_dannetsu == 3)
        },
        /**
         * @returns Boolean 住宅が木造か否か
         */
        isMokuzou() {
            return this.ip_structure == 1
        },
        /*
         * @returns Boolean 8地域か
         */
        isOndanchi() {
            return this.env_chiki == 8
        }
    },
    mixins:[help, master],
    methods:{
        ...mapActions('data', ['update']),
    }
}
</script>

